






















import Component, { mixins } from 'vue-class-component';
import UrlMixin from '@/mixins/url';
import TextLink from '@/components/Atoms/Link/TextLink.vue';

@Component({
  components: {
    TextLink,
  },
})
export default class PhoneLead extends mixins(UrlMixin) {
  get entryType(): string {
    return this.$store.getters['hikari/entryType'];
  }
}
